import {PIXELS_PER_METER} from "@/dungeons/geometry/Coordinates.ts";
import type {WorldPoint} from "@/dungeons/model/DungeonGeometry.ts";

/** World-space dimensions: 20 cm radius and 4 cm gap from a linked token's frame. */
export const LIGHT_MARKER_WORLD_RADIUS = 0.2 * PIXELS_PER_METER;
const LIGHT_MARKER_WORLD_GAP = 0.04 * PIXELS_PER_METER;

export function lightMarkerLayout(origin: WorldPoint, tokenSize?: number) {
    const radius = LIGHT_MARKER_WORLD_RADIUS;
    if (tokenSize === undefined) return {position: origin, radius};

    const tokenFrameRadius = tokenSize * 0.5;
    const centerDistance = tokenFrameRadius + radius + LIGHT_MARKER_WORLD_GAP;
    const diagonalOffset = centerDistance / Math.SQRT2;
    return {
        position: {x: origin.x + diagonalOffset, y: origin.y - diagonalOffset},
        radius,
    };
}
